import PropTypes from 'prop-types';
import React from 'react';

import { ABBEY } from '@wetransfer/transfer/constant/colors';

const Pencil = ({ className, color }) => (
  <svg
    className={className}
    fill={color}
    fillRule="evenodd"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m17.1199 7.17901-1.4639 1.49008-4.2682-4.27769 1.4579-1.48404c1.1541-1.17453 3.0407-1.18965 4.2129-.03327.009.00806.009.00806.0171.01613l.0271.02823c1.1732 1.17453 1.1803 3.07696.0171 4.26056zm-8.87738 9.03529-5.55706 1.1634 1.27884-5.431 6.01084-6.11764 4.26916 4.27664zm10.28408-14.72142-.0282-.02822-.0272-.02722c-1.965-1.937722-5.1254-1.913526-7.0593.05544l-8.88139 9.04032c-.25859.2621-.4407.5918-.52421.9517l-2.0063 8.5151 8.65404-1.8117c.38838-.0806.74457-.2762 1.02227-.5585l8.87739-9.03632c1.9389-1.97301 1.9268-5.14271-.0271-7.1006z"
      fill="#5c5e61"
    />
  </svg>
);

Pencil.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Pencil.defaultProps = {
  color: ABBEY,
};

export default Pencil;
